import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkHTML from 'remark-html';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import Button from '@mui/material/Button';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import BoltIcon from '@mui/icons-material/Bolt';
import './QuestionPanel.css';
import { FormatColorReset } from '@mui/icons-material';

interface QuestionPanelProps {
	questionData: any;
}

const Diff = {
	EASY: '#66C61C',
	MEDIUM: '#EAAA08',
	HARD: '#FF4D4F',
};

const QuestionPanel: React.FC<QuestionPanelProps> = ({ questionData }) => {
	const [ShowHints, SetShowHints] = useState(false);
	const [Hint, SetHint] = useState(0);
	console.log('question Data', questionData);
	return (
		<div style={{ margin: '20px 20px 80px 20px', position: 'relative' }}>
			<ReactMarkdown
				className={`markdown-body`}
				rehypePlugins={[[rehypeHighlight], [rehypeRaw]]}
				remarkPlugins={[remarkGfm, remarkHTML]}
			>
				{questionData.statement}
			</ReactMarkdown>
		</div>
	);
};

export default QuestionPanel;
